import { render, staticRenderFns } from "./ModalMessageViews.vue?vue&type=template&id=6635d81e&scoped=true"
import script from "./ModalMessageViews.vue?vue&type=script&lang=js"
export * from "./ModalMessageViews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6635d81e",
  null
  
)

export default component.exports